<template>
  <div>
    <v-row
      dense
      class="pa-2 mb-2 bg-white">
      <v-col>
        <v-form
            ref="form"
            v-model="formValid"
          >
            <v-row>
              <v-col md="1" class="text-no-wrap">
                TO:
              </v-col>
              <v-col md="11">
                {{ formattedSendMailTo }}
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col md="1" class="text-no-wrap">
                Cc:
              </v-col>
              <v-col md="11">
                {{ mailCc }}
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col md="1" class="text-no-wrap">
                差出人:
              </v-col>
              <v-col md="11" class="py-0">
                <v-select
                  v-model="mailFrom"
                  :items="salesManagerItems"
                />
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col md="1" class="text-no-wrap">
                件名:
              </v-col>
              <v-col md="11" class="py-0">
                <v-text-field
                  v-model="monthlyReportMail.title"
                  :rules="[required]"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row class="mt-0 mb-0">
              <v-col md="1" class="text-no-wrap">
                本文:
              </v-col>
              <v-col md="11" class="pb-0">
                <v-textarea
                  v-model="monthlyReportMail.body"
                  :rules="[required]"
                  hide-details
                  rows="20"
                />
              </v-col>
        </v-row>
        </v-form>
      </v-col>
    </v-row>

    <v-row
      class="mt-3"
      justify="center"
    >
      <v-btn
        variant="flat"
        border="md"
        class="mr-2 text-glance-primary font-weight-bold border-current"
        @click="saveDraft"
      >
        下書き保存
      </v-btn>

      <v-btn
        variant="flat"
        border="0"
        :color="color.mainColor()"
        class="ml-2 text-white font-weight-bold"
        :disabled="!formValid"
        @click="sendMail"
      >
        すぐに送信
      </v-btn>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, ref } from "vue"
import { useStore } from "../../stores/index"
import { Manager } from "../../stores/store_types"
import { themeColor } from "../../service/theme_color"
export default defineComponent({
  name: "MonthlyMailEditPart",
  setup() {
    const store = useStore()
    const form = ref<HTMLFormElement>()
    // settings
    const color = themeColor()

    // data
    const currentUser = computed(() => store.getters.currentUser)
    const formattedSendMailTo = computed(() => store.getters.monthlyMailRecipients.map((mailTo: { formatted: string }) => mailTo.formatted).join(","))
    const mailCc = ref("business@kids-public.co.jp")
    const monthlyReportMail = computed(() => store.getters.monthlyReportMail)
    const salesManagers  = computed(() => store.getters.salesManagers)
    const salesManagerItems = salesManagers.value.map((manager: Manager) => ({ title: manager.formatted, value: manager.id }))
    const mailFrom = ref(currentUser.value.id)
    const formValid = ref(false)

    const sendMail = () => {
      // バリデーション
      monthlyReportMail.value.to = formattedSendMailTo.value
      monthlyReportMail.value.from = salesManagers.value.find((manager: { id: number }) => manager.id == mailFrom.value).formatted
      store.dispatch("fixMonthlyReportMail", monthlyReportMail.value)
    }

    const saveDraft = () => {
      monthlyReportMail.value.to = formattedSendMailTo.value
      monthlyReportMail.value.from = salesManagers.value.find((manager: { id: number }) => manager.id == mailFrom.value).formatted
      store.dispatch("saveDraftMonthlyReportMail", monthlyReportMail.value)
    }

    const required = (input: string) => {
      return !!input || "入力必須です"
    }

    onMounted(() => {
      store.dispatch("fetchSalesManagers")
      if(form.value) {
        form.value.validate()
      }
    })

    return {
      monthlyReportMail,
      formattedSendMailTo,
      mailCc,
      salesManagerItems,
      mailFrom,
      formValid,
      form,
      color,
      sendMail,
      saveDraft,
      required
    }
  }
})
</script>
